// Phase 2 — Deactivate-MID modal extracted from Merchants.jsx.
// Captures last-transacting date + reason. Past calculations stay frozen
// (closed_periods.totals); only forward-looking views filter on `status`.

import { Btn, Modal, Input } from "@/components/Shared";

export default function MerchantDeactivateModal({ open, target, form, setForm, busy, onCancel, onConfirm }) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={target ? `Deactivate ${target.merchant_id}` : "Deactivate"}
      testid="deactivate-merchant-modal"
      size="md"
    >
      {target && (
        <div className="space-y-4">
          <div className="text-[12px] text-[var(--muted)]">
            Mark <b className="text-[var(--ink)]">{target.merchant_name}</b> ({target.merchant_id}) as no longer transacting.
            Historical reports stay unchanged; this MID will only be hidden from forward-looking views.
          </div>
          <div>
            <label className="text-[11px] uppercase text-[var(--muted)] font-semibold tracking-wider">
              Last transacting date <span className="text-[var(--negative)]">*</span>
            </label>
            <Input
              type="date"
              value={form.deactivation_date}
              onChange={(e) => setForm({ ...form, deactivation_date: e.target.value })}
              data-testid="deactivate-date-input"
            />
            <div className="text-[10.5px] text-[var(--muted)] mt-1">
              Volume rows uploaded for periods after this date will trigger a soft warning at import.
            </div>
          </div>
          <div>
            <label className="text-[11px] uppercase text-[var(--muted)] font-semibold tracking-wider">
              Reason <span className="text-[var(--negative)]">*</span>
            </label>
            <Input
              value={form.reason}
              onChange={(e) => setForm({ ...form, reason: e.target.value })}
              placeholder="Merchant churn — moved to Razorpay"
              data-testid="deactivate-reason-input"
            />
          </div>
          <div className="flex justify-end gap-2 pt-1">
            <Btn variant="ghost" onClick={onCancel} testid="deactivate-cancel">Cancel</Btn>
            <Btn variant="accent" onClick={onConfirm} disabled={busy} testid="deactivate-confirm">
              {busy ? "Deactivating…" : "Deactivate MID"}
            </Btn>
          </div>
        </div>
      )}
    </Modal>
  );
}
